import React from "react";
import { Alert, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BLOCK_MESSAGES = {
  subscription_expired: "Your subscription has expired. Renew to continue using WhatsApp features.",
  no_subscription: "Subscribe to a plan to continue using WhatsApp features.",
};

export default function SubscriptionAccessBanner({ account }) {
  const navigate = useNavigate();
  const access = account?.getSubscriptionAccess?.();
  if (!access) return null;

  const isBlocked = access.access_status === "blocked" || access.can_go_online === false;
  const isGrace = access.access_status === "grace";

  if (!isBlocked && !isGrace) return null;

  const message = isBlocked
    ? (BLOCK_MESSAGES[access.block_reason] || access.block_reason || BLOCK_MESSAGES.subscription_expired)
    : "Your subscription grace period is active. Renew soon to avoid losing access.";

  return (
    <Alert
      severity={isBlocked ? "error" : "warning"}
      sx={{ borderRadius: 0, flexShrink: 0 }}
      action={(
        <Button color="inherit" size="small" onClick={() => navigate("/plans")}>
          View plans
        </Button>
      )}
    >
      {message}
    </Alert>
  );
}
